import { render } from "./TextareaPage.vue?vue&type=template&id=bc2c3002&scoped=true"
import script from "./TextareaPage.vue?vue&type=script&lang=js"
export * from "./TextareaPage.vue?vue&type=script&lang=js"

import "./TextareaPage.vue?vue&type=style&index=0&id=bc2c3002&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2c3002"]])

export default __exports__